module.exports = __webpack_public_path__ + "static/media/cert_3.d5aba6a5.jpg";